import { httpClient } from '@bcba/client-auth';

export const deleteStorageFacility = async (uuid: string) => {
  return httpClient.delete(`/storage-facilities/${uuid}`);
};
